import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";

const styles = createUseStyles({
  managedCompanyBar: {
    backgroundColor: colors.aquaBlue,
    position: "fixed",
    top: 0,
    display: "flex",
    justifyContent: "space-between",
    textAlign: "center",
    alignItems: "center",
    width: "100%",
    height: "52px",
    zIndex: 1051,
    "& p": {
      color: colors.grey,
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "20px",
      margin: "auto 16px auto 0px"
    }
  },
  manageButton: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
    color: colors.mediumGrey,
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    cursor: "pointer",
    marginLeft: "16px",
  }
});

export default styles;

